import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    quizState: {},      // answered questions
    quizScore: {
      kurtz: 0,
      marlow: 0,
      accountant: 0,
      manager: 0,
    },
    quizCurrentIndex: 0,
  },
  mutations: {
    UPDATE_QUIZ_STATE(state, p: any) {
      (state.quizState as any)[p.id] = p.choice
    },
    UPDATE_QUIZ_INDEX(state, index) {
      state.quizCurrentIndex = index
    },
    UPDATE_QUIZ_SCORE_FOR_CHAR(state, p: any) {
      if (p.character in state.quizScore) {
        (state.quizScore as any)[p.character] += ((p.score - 3) * (p.isNegative ? -1 : 1))
      }
    }
  },
  actions: {

  },
});
